import * as React from 'react';
import superagent from 'superagent';

const css = require('./index.scss');

export interface IIconProps {
    src: string;
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

export default function Icon(props: IIconProps) {

    const className = () => {
        return className ? `${css.icon} ${className}` : css.icon;
    };

    const [htmlString, setHtmlString] = React.useState('');

    React.useEffect(() => {
        superagent.get(props.src).end((err, res) => {
            if (!err) {
                setHtmlString(res.text);
            }
        });
    }, []);

    return (
        <i className={`anticon ${className()}`} dangerouslySetInnerHTML={{ __html: htmlString }} />
    );
}


// WEBPACK FOOTER //
// ./src/display/components/Icon/index.tsx